import { handleResponse } from "../_helpers/handle-response";
import { authHeaderWithOutToken } from "../_helpers/auth-header.js";
import { BASE_URL } from "../_constants/services.constants.js";

const accessoryfinderService = {
  getAllBrands,
  getVacuumModelsByBrand,
  getModelSeries,
  getAllAccessories,
  getAccessoriesDetail,
  getProductDetail,
};

function getAllBrands() {
  return fetch(`${BASE_URL}/Model/GetAllBrands`).then(handleResponse);
}
function getVacuumModelsByBrand(id) {
  return fetch(`${BASE_URL}/Model/GetVacuumModelsByBrand/` + id).then(
    handleResponse,
  );
}
function getModelSeries(id) {
  return fetch(`${BASE_URL}/Series/GetModelSeries/` + id).then(handleResponse);
}
function getAllAccessories() {
  return fetch(`${BASE_URL}/AllAccessories/GetAllAccessories`).then(
    handleResponse,
  );
}
function getAccessoriesDetail(formData) {
  return fetch(`${BASE_URL}/AccessorySearch/GetAccessoriesFromModel`, {
    method: "post",
    headers: authHeaderWithOutToken(),
    body: formData,
  }).then(handleResponse);
}
function getProductDetail(formData) {
  return fetch(`${BASE_URL}/ModelSearch/GetModelsFromAccessory`, {
    method: "post",
    headers: authHeaderWithOutToken(),
    body: formData,
  }).then(handleResponse);
}
export default accessoryfinderService;
